import React from "react";
import { buttonVariants } from "../ui/button";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CancelAppointmentModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full mx-4">
        <h2 className="text-lg font-bold ">Confirm Cancellation</h2>
        <p className="mt-2 text-sm">
          Are you sure you want to cancel this appointment? This action cannot be undone.
        </p>
        <div className="mt-4 flex justify-end gap-3">
          <button
            onClick={onClose}
            className={buttonVariants({
              variant: "ghost",
              className: "hover:bg-gray-100",
            })}
          >
            No
          </button>
          <button
            onClick={onConfirm}
            className={buttonVariants({
              variant: "default",
              className: "bg-teal-700 hover:bg-teal-900",
            })}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelAppointmentModal;
